import Navbar from "./components/Navbar";
import { Routes, Route, Navigate } from "react-router";
import HomePage from "./pages/home";
import InterviewPage from "./pages/interview";
import LoginPage from "./pages/login";
import GithubCallBackPage from "./pages/github";
import MyPage from "./pages/myPage";
import "./App.css";
import InterviewDetail from "./pages/myPage/InterviewsDetail";
import AdminPage from "./pages/admin";
import BetaBanner from "./components/BetaBanner";
import { useEffect, useState } from "react";
import VoiceInput from "./components/speech/VoiceInput";

function App() {
  const [visible, setVisible] = useState(true);

  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.error = () => {};
  }

  return (
    <>
      <BetaBanner setVisible={setVisible} visible={visible} />
      <Navbar visible={visible} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/practice" element={<InterviewPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/my-page" element={<MyPage />} />
        <Route path="/interview/:id" element={<InterviewDetail />} />
        <Route path="/github/callback" element={<GithubCallBackPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
